import * as React from 'react';

export const Loading = () => <div>loading</div>;
